import { render, staticRenderFns } from "./BaseLogin.vue?vue&type=template&id=2449bc86&scoped=true&"
import script from "./BaseLogin.vue?vue&type=script&lang=js&"
export * from "./BaseLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2449bc86",
  null
  
)

export default component.exports